import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';
import Util from '../../forecast-app/shared/util/util';
import InlineLoader from '../../forecast-app/shared/components/inline-loader/inline_loader';
import GenericModal from './generic_modal';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import {Checkbox} from 'web-components';
import ImportJiraUsersMutation from '../../mutations/ImportJiraUsersMutation';

class JiraSyncUsersModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			jiraUsers: [],
			fetchingUsers: true,
			selectedUsers: [],
		};

		this.getUsers();
	}

	getUsers() {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const init = {headers: headers, credentials: 'include', method: 'GET'};

		fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'jira/' + this.props.jiraType + '/users', init)
			.then(result => result.json())
			.then(users => {
				this.setState({
					jiraUsers: users.sort((a, b) => (a.displayName > b.displayName ? 1 : -1)),
					fetchingUsers: false,
				});
			});
	}

	toggleSelectAll() {
		if (this.state.selectAll) {
			this.setState({
				selectedUsers: [],
				selectAll: false,
			});
		} else {
			this.setState({
				selectedUsers: this.state.jiraUsers.map(jiraUser => (this.props.jiraType === 'cloud' ? jiraUser.accountId : jiraUser.key)),
				selectAll: true,
			});
		}
	}

	toggleUser(jiraId) {
		if (this.state.selectedUsers.includes(jiraId)) {
			const selectedUsers = this.state.selectedUsers.filter(userId => userId !== jiraId);
			this.setState({
				selectedUsers,
				selectAll: false,
			});
		} else {
			const selectedUsers = this.state.selectedUsers;
			selectedUsers.push(jiraId);
			this.setState({
				selectedUsers,
			});
		}
	}

	syncUsers() {
		const onSuccess = () => {
			// something
		};

		Util.CommitMutation(
			ImportJiraUsersMutation,
			{
				jiraPersonIds: this.state.selectedUsers,
				jiraType: this.props.jiraType,
			},
			onSuccess
		);
	}

	render() {
		const {formatMessage} = this.props.intl;
		const content = (
			<div className="unit4-sync-users-modal-content">
				<div className="unit4-sync-users-modal-description">
					<FormattedMessage id="modal.jira.sync_users.description" />
				</div>
				{this.state.fetchingUsers ? (
					<InlineLoader />
				) : this.state.jiraUsers.length === 0 ? (
					<FormattedMessage id="modal.jira.sync_users.empty" />
				) : (
					<CustomScrollDiv autoHeight autoHeightMin={10} autoHeightMax={'60vh'}>
						<div className="unit4-users">
							<div className="unit4-user" key={'0'}>
								<Checkbox checked={this.state.selectAll} onClick={this.toggleSelectAll.bind(this)} />
								<FormattedMessage id="common.select_all" />
							</div>
							{this.state.jiraUsers.map(jiraUser => (
								<div className="unit4-user" key={jiraUser.accountId || jiraUser.key}>
									<Checkbox checked={this.state.selectedUsers.includes(jiraUser.accountId || jiraUser.key)} onClick={this.toggleUser.bind(this, jiraUser.accountId || jiraUser.key)} />
									{`${jiraUser.displayName}${jiraUser.emailAddress ? ` (${jiraUser.emailAddress})` : ''}`}
								</div>
							))}
						</div>
					</CustomScrollDiv>
				)}
			</div>
		);

		return (
			<GenericModal
				headerText={<FormattedMessage id="common.sync_users" />}
				closeModal={this.props.closeModal}
				className="unit4-sync-users-modal"
				buttons={[
					{
						text: formatMessage({id: 'common.cancel'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
					{
						text: formatMessage({id: 'common.create_x_users'}, {numOfUsers: this.state.selectedUsers.length}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.GREEN,
						callback: this.syncUsers.bind(this),
						disabled: this.state.selectedUsers.length === 0,
					},
				]}
				content={content}
			/>
		);
	}
}

export default injectIntl(withRouter(JiraSyncUsersModal));
